import React from 'react';
import { Col, Row } from 'rsuite';
import { Category } from './Category';

export const Categories = ({ categories }) => {
  return (
    <Row>
      {categories.map((item) => {
        return (
          <Col xs={24} sm={12} md={6} key={item.term_id}>
            <Category {...item} />
          </Col>
        );
      })}
    </Row>
  );
};
